import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import EnterpriseBox from './components/EnterpriseBox'
import ResearchGroupMemberBox from './views/User/MyResearchGroup/researchGroupComponents/ResearchGroupMemberBox'
import SearxhBox from './views/search/SearchBox'
import SearchGeneBox from './views/search/SearchGeneBox'
import PoPupTextBox from './views/search/PoPupTextBox'
import InvoiceTitleBox from './views/search/invoiceTitleBox'
import SearchFilterPanel from './views/Panel/SearchFilterPanel'
import router from './router'
import store from './store/index'
import VueResource from 'vue-resource'
import Emkt from './emkt'
import $ from 'jquery'
import './assets/iconfont/iconfont.css'
import weui from 'weui.js'
import Vant from 'vant'
import '@/icons'
import 'vant/lib/index.css'

import animated from 'animate.css'

Vue.use(animated)

Vue.prototype.$weui = weui
// console.log('weui', weui)
// $weui.dialog replace light7 $.modal & $.confirm
// $weui.alert replace light7 $.alert & alert
// $weui.toast replace light7 $.toast(successMessage)
// $weui.topTips replace light7 $.toast(errorMessage)
// $weui.loading replace light7 $.showPreloader()
// $weui.loading().hide() replace light7 $.hidePreloader()
Vue.use(Vant)

Vue.prototype.store = store
Vue.prototype.emkt = Emkt
Vue.config.productionTip = false
Vue.use(VueResource)
window.emkt = Emkt

if (process.env.NODE_ENV === 'development') {
  // Vue.http.options.root = 'static/test'
  Vue.http.options.root = 'gcapi'
} else if (process.env.NODE_ENV === 'development2') {
  Vue.http.options.root = 'gcapi'
} else if (process.env.NODE_ENV === 'development3') {
  Vue.http.options.root = 'gcapi'
} else if (process.env.NODE_ENV === 'development4') {
  Vue.http.options.root = 'gcapi'
} else {
  Vue.http.options.root = 'gcapi'
}
// redirect to smart
if (Emkt.getUrlParamHref('toSmart') === '1') {
  const uri = window.location.href.split('#')[0]
  const uriItems = uri && uri.split('?')
  const processDomain = uriItems[0] && uriItems[0].includes('http://www.genechemat.com') && uriItems[0].replace('http', 'https') || uriItems[0]
  const newUri = uriItems && `${processDomain}/rtmes-client/?${uriItems[1]}`
  let replaceSmartUri = newUri && newUri.replace('&toSmart=1', '')
  console.log('toSmart', replaceSmartUri)
  window.location.href = replaceSmartUri
}

if (Emkt.getUrlParam('debug')) {
  Emkt.isDebug = true
}

if (Emkt.getUrlParamHref('desktop') === '1') {
  Emkt.isDesktop = true
}
if (window) {
  Emkt.isIphoneFullScreen = /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812
}

if (Emkt.getFullUrlParam('wapp')) {
  Emkt.isWapp = true
}
if (Emkt.getFullUrlParam('openid')) {
  Emkt.isWappGuest = true  // 小程序Guest跳转
  store.state.customerOpenId = Emkt.getUrlFullParamValue('openid')
  if (store.getters.hasLogin) {
    this.gcapi('gcwwwifc/userLogout')
      .then((response) => {
        if (response.body.code === 1) {
          this.$weui.toast('同步登录状态失败！')
        }
      }, (response) => {
        this.$weui.toast('同步登录状态失败！')
      })
  }
}
// 从小程序过来 且为全面屏 需要做适配
Emkt.leaveSpaceForFullScreen = Emkt.isWapp && Emkt.isIphoneFullScreen
// if (Emkt.getFullUrlParam('session')) {
//   alert(window.location.href)
// }
Emkt.getEmktMetaVersion() // init

if (Emkt.getUrlParamHref('sso_processed') === '1') {
  Emkt.buyCartIsLocalStorage = false
}
if (window.location.href.indexOf('secpromotion') !== -1) {
  Emkt.isSecPromotion = true
}
if (Emkt.getFullUrlParam('shareCartId')) {
  // 不存储在window.localstorage，每次进入应用时都重新获取并存储
  Emkt.setStoreItem('shareCartId', Emkt.getFullUrlParam('shareCartId'))
}
if (Emkt.getUrlParamHref('QuoteStatus')) {
  if (Emkt.getUrlParamHref('QuoteStatus') === '0' || Emkt.getUrlParamHref('QuoteStatus') === '3') {
    Emkt.setLocalStorage('QuoteStatus', false)
  } else {
    Emkt.setLocalStorage('QuoteStatus', true)
  }
} else {
  Emkt.setLocalStorage('QuoteStatus', false)
}

/*  Vue.http.options.root = process.env.NODE_ENV === 'development' ? 'static/test' : 'api' */
Vue.http.options.emulateJSON = true
Vue.http.interceptors.push(function (request, next) {
  // request.headers.set('EmktMetaVersion', '' + Emkt.getEmktMetaVersion())
  // window.document.cookie = 'EmktMetaVersion=' + Emkt.getEmktMetaVersion()
  if (process.env.NODE_ENV === 'development') {
    // request.url = request.url + '.json'
  } else {
    // request.url = request.url + '.json'
  }

  next(function (response) {
    // 处理元数据
    dealMetaData(response)
  })
})
function dealMetaData (response) {
  if (response.body.attrs !== undefined) {
    if (response.body.attrs.EmktMetaData !== undefined) {
      var merchandiseMeta = response.body.attrs.EmktMetaData
      var detaillist
      var categoryAttrsMap = {}
      // var dictionariesMapNew = {}
      var dictionariesMap = {}
      var tagsMap = {}
      var tagIdsMap = {}
      var tagNamesMap = {}
      var dictionaries
      var categoryAttrGroups
      var categoryAttrGroupsMap = {}
      var tags
      var categories
      var categoriesMap = {}
      // var val = []
      detaillist = merchandiseMeta.categoryAttrs
      dictionaries = merchandiseMeta.dictionaries
      categoryAttrGroups = merchandiseMeta.categoryAttrGroups
      tags = merchandiseMeta.tags
      categories = merchandiseMeta.categories

      for (var j = 0; j < dictionaries.length; j++) {
        var dkey = dictionaries[j].typeID + '_' + dictionaries[j].dictKey
        var dvalue = dictionaries[j]
        var keyNew = dictionaries[j].typeID
        dictionariesMap[dkey] = dvalue
        var dictionariesEntry = dictionariesMap[keyNew]
        if (!dictionariesEntry) {
          dictionariesMap[keyNew] = {}
          dictionariesEntry = dictionariesMap[keyNew]
        }
        dictionariesEntry[dictionaries[j].dictKey] = dvalue
      }

      for (j = 0; j < categoryAttrGroups.length; j++) {
        var k = categoryAttrGroups[j].attrGroupId
        var v = categoryAttrGroups[j]
        categoryAttrGroupsMap[k] = v
      }

      for (var i = 0; i < detaillist.length; i++) {
        var attrsMap = categoryAttrsMap[detaillist[i].categoryId]
        if (!attrsMap) {
          attrsMap = {}
          categoryAttrsMap[detaillist[i].categoryId] = attrsMap
        }

        // var key = detaillist[i].categoryId + '_' + detaillist[i].columnName
        var value = detaillist[i]
        // categoryAttrsMap[key] = value
        attrsMap[detaillist[i].columnName] = value
      }
      for (let k = 0; k < tags.length; k++) {
        var tkey = tags[k].tagId
        var tvalue = tags[k]
        tagsMap[tkey] = tvalue
      }
      for (let k = 0; k < tags.length; k++) {
        var tidkey = tags[k].tagId
        var tidvalue = tags[k].tagLabel
        tagIdsMap[tidkey] = tidvalue
      }
      for (let k = 0; k < tags.length; k++) {
        var tnamekey = tags[k].tagLabel
        var tnamevalue = tags[k].tagId
        tagNamesMap[tnamekey] = tnamevalue
      }
      for (let i = 0; i < categories.length; i++) {
        var cate = categories[i].categoryId
        var cateValue = categories[i]
        categoriesMap[cate] = cateValue
      }

      merchandiseMeta.categoryAttrsMap = categoryAttrsMap
      merchandiseMeta.dictionariesMap = dictionariesMap
      merchandiseMeta.categoryAttrGroupsMap = categoryAttrGroupsMap
      merchandiseMeta.tagsMap = tagsMap
      merchandiseMeta.tagIdsMap = tagIdsMap
      merchandiseMeta.tagNamesMap = tagNamesMap
      merchandiseMeta.keywordMeanings = merchandiseMeta.keywordMeanings
      merchandiseMeta.categoriesMap = categoriesMap
      Emkt.setLocalStorage('EmktAllKeywords', {}) // 同时要清空keyWords
      if (!window.localStorage) {
        // window.localStorage.clear()
      }
      if (Emkt.isDebug) {
        window.alert('merchandiseMeta=' + merchandiseMeta)
      }
      Emkt.setEmktMetaData(merchandiseMeta)
    }
  }
}

function setMerchandiseListWithMeta (merchandises) {
  merchandises.forEach(function (item) {
    if (item.compositions) {
      setMerchandiseListWithMeta(item.compositions)
    }
    Emkt.merchandiseWithMeta(item)
  })
}

function setOrderMerchandiseWithMeta (orders) {
  for (let i = 0; i < orders.length; i++) {
    let order = orders[i]
    if (order.merchandises[0]) {
      order.merchandises[0].productName = order.productName
    }
    setMerchandiseDetailForClient(order.merchandises, order.isSmartOrder)
  }
}

function setMerchandiseDetailForClient (merchandises, isSmartOrder = false) {
  if (merchandises) {
    merchandises.forEach(function (item) {
      let mer = item.merchandiseDetailForClient
      if (mer) {
        if (mer.categoryId === 10 || mer.categoryId === 20) {
          setMerchandiseDetailForClientCustom(item)
        }
        if (!isSmartOrder) {
          Emkt.merchandiseWithMeta(mer)
          item._attributesList = mer._attributesList
          item._titleList = mer._titleList
          item._subTitleList = mer._subTitleList
          item._attributes = mer._attributes
          item._abstractList = mer._abstractList
          item.priceMax = mer.priceMax
        }
      }
    })
  }
}

function setMerchandiseDetailForClientCustom (item) {
  let attributes = item.attributes
  let obj = {}
  let mer = item.merchandiseDetailForClient
  attributes.forEach(data => {
    let key = data.key
    let val = data.value
    obj[key] = val
  })
  mer.productName = item.productName
  mer.attributes = obj
  mer.cycle = item.workdays
  mer.priceMax = item.priceMax
  mer.priceMin = item.priceMin
  // mer.priceMax = item.price
  // mer.priceMin = item.price
  mer.productGuid = item.productGuid
  return mer
}
// || response.apiName === 'assambleOrders'
function retrieveMyOrder (response) {
  if (response.apiName === 'retrieveMyOrder') {
    let re = response.body.result
    let canceledOrders = re.canceledOrders
    let finishedOrders = re.finishedOrders
    let waitDeliverOrders = re.waitDeliverOrders
    let waitPaidOrders = re.waitPaidOrders
    let waitSignOrders = re.waitSignOrders
    let completeOrders = re.completeOrders
    let quoteCompletedOrders = re.quoteCompletedOrders
    let waitAuditOrders = re.waitAuditOrders
    let failAuditOrders = re.failAuditOrders
    waitSignOrders = getProductNum(waitSignOrders)
    completeOrders = getProductNum(completeOrders)
    quoteCompletedOrders = getProductNum(quoteCompletedOrders)
    waitAuditOrders = getProductNum(waitAuditOrders)
    failAuditOrders = getProductNum(failAuditOrders)

    canceledOrders = getProductNum(canceledOrders)
    finishedOrders = getProductNum(finishedOrders)
    waitDeliverOrders = getProductNum(waitDeliverOrders)
    waitPaidOrders = getProductNum(waitPaidOrders)

    setOrderMerchandiseWithMeta(waitSignOrders)
    setOrderMerchandiseWithMeta(completeOrders)
    setOrderMerchandiseWithMeta(quoteCompletedOrders)
    setOrderMerchandiseWithMeta(waitAuditOrders)
    setOrderMerchandiseWithMeta(failAuditOrders)

    changeorders(waitSignOrders)
    changeorders(completeOrders)
    changeorders(quoteCompletedOrders)
    changeorders(waitAuditOrders)
    changeorders(failAuditOrders)

    setOrderMerchandiseWithMeta(canceledOrders)
    setOrderMerchandiseWithMeta(finishedOrders)
    setOrderMerchandiseWithMeta(waitDeliverOrders)
    setOrderMerchandiseWithMeta(waitPaidOrders)
    changeorders(canceledOrders)
    changeorders(finishedOrders)
    changeorders(waitDeliverOrders)
    changeorders(waitPaidOrders)
    let commentedMerchandise = re.commentedMerchandise
    let waitCommentMerchandise = re.waitCommentMerchandise
    setMerchandiseDetailForClient(commentedMerchandise)
    setMerchandiseDetailForClient(waitCommentMerchandise)
    // console.log(commentedMerchandise)
  }
  if (response.apiName === 'assambleOrders') {
    setOrderMerchandiseWithMeta([response.body.result])
  }
}
function orderSubmit (response) {
  if (response.apiName === 'orderSubmit') {
    let re = response.body.result
    setMerchandiseDetailForClient(re.merchandises)
  }
}
function getWaitPayOrderInfoByOrderId (response) {
  if (response.apiName === 'getWaitPayOrderInfoByOrderId') {
    let re = [response.body.result]
    setOrderMerchandiseWithMeta(re)
    changeorders(re)
  }
}
function calculateOrderAmount (response) {
  if (response.apiName === 'calculateOrderAmount' && response.body.result) {
    let re = response.body.result
    setMerchandiseDetailForClient(re.merchandises)
  }
}

function getAllOrdersByCustomerNoOrResearchGroupNo (response) {
  if (response.apiName === 'getAllOrdersByCustomerNoOrResearchGroupNo' && response.body.result) {
    let re = response.body.result
    for (let key in re) {
      re[key].forEach(order => {
        order.fromEmkt && order.itemList && order.itemList.forEach(item => {
          item.fromEmkt = order.fromEmkt
          let convertedAttributes = {}
          if (!item.attrs) console.log('empty attrs: key', key, order, item)
          item.attrs && item.attrs.forEach(attr => {
            convertedAttributes[attr.attribute] = attr.value
          })
          item.attributes = convertedAttributes
          Emkt.merchandiseWithMeta(item)
        })
      })
    }
  }
}

function changeorders (orders) {
  for (var j = 0; j < orders.length; j++) {
    if (orders[j].subOrders && orders[j].subOrders.length > 0) {
      setOrderMerchandiseWithMeta(orders[j].subOrders)
    }
  }
}
function getProductNum (productList) {
  if (productList) {
    var i = 0
    var j = 0
    for (i = 0; i < productList.length; i++) {
      if (productList[i].merchandises && productList[i].merchandises.length > 0) {
        var l = 0
        if (productList[i].isStock === false) {
          l = productList[i].merchandises.length
        } else {
          for (j = 0; j < productList[i].merchandises.length; j++) {
            l = l + productList[i].merchandises[j].quantity
          }
        }
        productList[i].productNum = l
      } else if (productList[i].subOrders && productList[i].subOrders.length > 0) {
        var k = 0
        for (j = 0; j < productList[i].subOrders.length; j++) {
          k = k + productList[i].subOrders[j].merchandises.length
        }
        productList[i].productNum = k
      }
    }
  }
  return productList
}
function getAllCustomizedMerchandise (response) {
  if (response.apiName === 'getAllCustomizedMerchandise') {
    setMerchandiseListWithMeta(response.body.result)
  }
}
function getMerchandiseDetails (response) {
  if (response.apiName === 'getMerchandiseDetails') {
    Emkt.merchandiseWithMeta(response.body.result)
  }
}
function findMerchandiseDetails (response) {
  if (response.apiName === 'findMerchandiseDetails') {
    Emkt.merchandiseWithMeta(response.body.result)
  }
}
function queryMerchandise (response) {
  if (response.apiName === 'queryMerchandise') {
    setMerchandiseListWithMeta(response.body.result.merchandiseList)
  }
}
function find (response) {
  if (response.apiName === 'find') {
    if (response.body.result.merchandiseList) {
      setMerchandiseListWithMeta(response.body.result.merchandiseList)
    }
  }
}
function getRecommended (response) {
  if (response.apiName === 'getRecommended') {
    setMerchandiseListWithMeta(response.body.result)
  }
}
function EmktPromotions (response) {
  if (response.apiName === 'EmktPromotions') {
    setMerchandiseListWithMeta(response.body.result)
  }
}
function procApplicableMerchandiseLiteList (response) {
  if (response.apiName === 'getApplicableMerchandiseLiteList') {
    setMerchandiseListWithMeta(response.body.result)
  }
}
function getRecommendation (response) {
  if (response.apiName === 'getRecommendation') {
    setMerchandiseListWithMeta(response.body.result)
  }
}
function productDetectCustom (response) {
  if (response.apiName === 'productDetect') {
    setMerchandiseDetailForClientCustom(response.body.result)
  }
}
function apiPostProc (response) {
  retrieveMyOrder(response)
  getAllCustomizedMerchandise(response)
  orderSubmit(response)
  getWaitPayOrderInfoByOrderId(response)
  getMerchandiseDetails(response)
  findMerchandiseDetails(response)
  procApplicableMerchandiseLiteList(response)
  getRecommended(response)
  queryMerchandise(response)
  find(response)
  EmktPromotions(response)
  getRecommendation(response)
  productDetectCustom(response)
  calculateOrderAmount(response)
  getAllOrdersByCustomerNoOrResearchGroupNo(response)
}
function gcapi (api, para, option) {
  var apiName = api
  var suppress = false
  if (apiName.startsWith('@')) { // 加@前缀的调用，启用错误抑制
    apiName = apiName.substring(1) // 去掉错误抑制前缀，取得API名字
    suppress = true
  }
  var apiDisplayName = apiName
  var idx = apiDisplayName.lastIndexOf('/')
  if (idx !== -1) {
    apiDisplayName = apiDisplayName.substring(idx)
  }
  return new Promise(function (resolve, reject) {
    apiCall(apiName, para, option).then(function (response) {
      response.apiName = apiName
      response.apiDisplayName = apiDisplayName
      if (response.body.code !== 0) {
        if (response.body.code === 101 && response.body.message === '') {
          // $.toast('啊哦～登录失败了')
          weui.topTips('啊哦～登录失败了', 1000)
          weui.loading().hide()
          return
        } else {
          // 发生了错误，处理错误信息
          response.code = response.body.code
          response.message = response.body.message

          if (Emkt.isDebug) {
            response.message = response.message + ': ' + apiDisplayName
            weui.topTips(response.message === '' ? '出错啦' : response.message)
            weui.loading().hide()
            // $.toast(response.message === '' ? '出错啦' : response.message)
          }

          response.statusText = response.message
          // 若联系人不存在，通知SF删除成员失败，验证余额账户时，验证结算账户可用信用额度， 前台需监测到此结果
          if (response.code === 1) {
            if (response.message === '该联系人不存在' || response.message.includes('通知SF删除成员失败') ||
              response.message === '缺少必要信息' || response.message.includes('可用信用额度')) {
              suppress = true
            }
          }
          if (suppress === false) {
            // 如果没有启用了错误消息抑制， 这里显示错误消息， 然后停止下游处理
            weui.topTips(response.message === '' ? '出错啦' : response.message)
            weui.loading().hide()
            // $.toast(response.message === '' ? '出错啦' : response.message)
            return
          }
        }
      }
      apiPostProc(response) // api结果预处理
      resolve(response)
    }, function (response) {
      response.apiName = apiName
      response.apiDisplayName = apiDisplayName
      response.message = response.statusText

      if (Emkt.isDebug) {
        response.message = response.message + ': ' + apiDisplayName
        weui.topTips(response.message === '' ? '出错啦' : response.message)
        weui.loading().hide()
        // $.toast(response.message === '' ? '出错啦' : response.message)
      }

      if (suppress === false) { // 如果没有启用了错误消息抑制， 这里显示错误消息
        weui.topTips(response.message === '' ? '出错啦' : response.message)
        weui.loading().hide()
        // $.toast(response.message === '' ? '出错啦' : response.message)
      }
      reject(response)
    })
  })
}

function apiCall (api, para, option) {
  var apiName = api
  if (apiName.startsWith('gcwwwifc/')) {
    // console.log(api, store.state.sessionInfo)
    if (store.state.sessionInfo.customerInfo) {
      return Vue.http.get(api, $.extend({params: para, SessionId: store.state.sessionInfo.customerInfo.session}, option))
    } else if (store.state.sessionInfo.session) {
      return Vue.http.get(api, $.extend({params: para, SessionId: store.state.sessionInfo.session}, option))
    } else {
      // if (Emkt.isWapp) {
      //   if (Emkt.getUrlParamHref('session')) {
      //     console.log(window.location.href)
      //     var sessionId = Emkt.getUrlFullParamValue('session')
      //     return Vue.http.get(api, $.extend({params: para, SessionId: sessionId}, option))
      //   }
      // } else {
      //   return Vue.http.get(api, $.extend({params: para}, option))
      // }
      return Vue.http.get(api, $.extend({params: para}, option))
    }
  }
  if (store.state.sessionInfo.customerInfo) {
    return Vue.http.post(api, {Json: JSON.stringify(para), SessionId: store.state.sessionInfo.customerInfo.session}, option)
  } else if (store.state.sessionInfo.session) {
    return Vue.http.post(api, {Json: JSON.stringify(para), SessionId: store.state.sessionInfo.session}, option)
  } else {
    // if (Emkt.isWapp) {
    //   if (Emkt.getUrlParamHref('session')) {
    //     console.log(window.location.href)
    //     sessionId = Emkt.getUrlFullParamValue('session')
    //     return Vue.http.post(api, {Json: JSON.stringify(para), SessionId: sessionId}, option)
    //   }
    // } else {
    //   return Vue.http.post(api, {Json: JSON.stringify(para)}, option)
    // }
    return Vue.http.post(api, {Json: JSON.stringify(para)}, option)
  }
  // return Vue.http.get(api, $.extend({params: {Json: JSON.stringify(para)}}, option))
}

Vue.prototype.gcapi = gcapi
/* eslint-disable no-new */
// 初始化客户端数据
let Curl = '@gcwwwifc/getCustomerInfo'
if (Emkt.isWapp && Emkt.getFullUrlParam('session')) {
  Curl = Curl + window.location.search
}
gcapi(Curl)
  .then(function (response) {
    let data = response.body
    if (data.code === 0) {
      store.state.sessionInfo = data.result
      // console.log('getCustomerInfo', store.state.sessionInfo)
      // console.log(Emkt.buyCartIsLocalStorage)
      let shoppingCart = store.state.sessionInfo.customerInfo.customerProperties.QuoteShoppingCart
      if (Emkt.buyCartIsLocalStorage === false && shoppingCart && shoppingCart !== 'null' && JSON.parse(shoppingCart).cartContent) {
        Emkt.setStoreItem('EmktBuyCart', JSON.parse(JSON.parse(shoppingCart).cartContent))
        // console.log(Emkt.getLocalStorage('EmktBuyCart'))
      }
    } else {
      return gcapi('@gcwwwifc/login', {
        'LoginId': 'guest',
        'Password': 'guest'
      })
    }
  })
  .then(function (response) {
    if (response !== undefined) {
      let res = response.body
      // console.log('response.body', res)
      if (res.code === 101) {
        // guest account
        store.state.sessionInfo = res.result
      } else if (res.code === 0) {
        // console.log('store.state.sessionInfo', store.state.sessionInfo)
        if (res.result) {
          store.state.sessionInfo.customerInfo = res.result
          // 更新sessionInfo以更新getters hasLogin
          store.state.sessionInfo = {...store.state.sessionInfo}
        }
        return gcapi('@gcwwwifc/getCustomerInfo')
      }
    }
  })
  .then(function (response) {
    if (response !== undefined) {
      let res = response.body
      if (res.code === 0) {
        store.state.sessionInfo = res.result
      }
    }
  })
  .then(function () {
    $.sign = {
      shareUrl: '',
      appId: '',
      timestamp: 0,
      nonceStr: '',
      signature: ''
    }
    // return gcapi('@gcwwwifc/getWechatTicket', {Url: location.origin + location.pathname + location.search})
  })
  // .then(function (res) {
  //   if (res) {
  //     let data = res.body
  //     if (data.code === 0) {
  //       let shareUrl = Emkt.wxShareUrl
  //       let sign = data.result
  //       if (store.getters.hasLogin && store.state.sessionInfo.customerInfo.customerNo) {
  //         let customerNo = store.state.sessionInfo.customerInfo.customerNo
  //         shareUrl += '?introducer=' + customerNo
  //       }
  //       $.sign = {
  //         shareUrl: shareUrl,
  //         appId: sign.appId,
  //         timestamp: +sign.timestamp,
  //         nonceStr: sign.nonceStr,
  //         signature: sign.signature
  //       }
  //     } else {
  //       $.sign = {
  //         shareUrl: '',
  //         appId: '',
  //         timestamp: 0,
  //         nonceStr: '',
  //         signature: ''
  //       }
  //     }
  //   }
  // })
  // .then(function () {
  //   // return gcapi('getBuyCart')
  // })
  // .then(function (res) {
  //   if (Emkt.buyCartIsLocalStorage === false) {
  //     // Emkt.setBuyCart('EmktBuyCart', store.state.sessionInfo.customerInfo)
  //   }
  // }
// .then(function () {
//   return gcapi('getSysParametersForAVVBlood')
// })
// .then(function (res) {
//   var BloodOptions = []
//   var BloodData = res.body.result
//   var BloodOptionsChoose = []
//   var specialBloodOptions = []
//   let BloodMaps = []
//   for (var i in BloodData) {
//     BloodOptions[BloodData[i].value] = BloodData[i].key
//     if (Emkt.extraBloodType.indexOf(BloodData[i].key) === -1) {
//       BloodOptionsChoose[BloodData[i].value] = BloodData[i].key
//     }
//     console.log(BloodData[i])
//     if (BloodData[i].wappCanUse === '1') {
//       specialBloodOptions[BloodData[i].value] = BloodData[i].key
//     }
//     BloodMaps[BloodData[i].key] = BloodData[i].organization
//   }
//   // console.log('BloodOptions', BloodOptions)
//   Emkt.setLocalStorage('BloodOptions', BloodOptions)
//   Emkt.setLocalStorage('BloodData', BloodData)
//   Emkt.setLocalStorage('BloodMaps', BloodMaps)
//   // console.log('BloodOptionsChoose', BloodOptionsChoose)
//   Emkt.setLocalStorage('BloodOptionsChoose', BloodOptionsChoose)
//   Emkt.setLocalStorage('SpecialBloodOptions', specialBloodOptions)
//   // console.log('SpecialBloodOptions---->', specialBloodOptions)
// })
  .then(function () {
    // if (!Emkt.isWapp || Emkt.isSecPromotion) {
    return gcapi('getHotPromotions')
    // }
  })
  .then(function (res) {
    // if (!Emkt.isWapp || Emkt.isSecPromotion) {
    if (res.body.result.length > 0) {
      getHotPromotions(res)
      getSecPromotion()
    } else {
      var promotions = []
      Emkt.setStoreItem('EmktDiscounts', null)
      Emkt.setStoreItem('EmktShowPromotions', promotions)
      Emkt.setStoreItem('EmktPromotions', promotions)
    }
    // }
  })
  .then(function (response) {
    if (!Emkt.isWapp) {
      var ShowPromotions = Emkt.getLocalStorage('EmktShowPromotions')
      if (store.getters.hasLogin && store.state.sessionInfo.customerInfo.customerNo) {
        if (ShowPromotions && ShowPromotions !== null && ShowPromotions.length > 0) {
          var showPromotionParam = {}
          showPromotionParam.bPromotions = ShowPromotions
          showPromotionParam.customerNo = store.state.sessionInfo.customerInfo.customerNo
          gcapi('ShowPromotions', showPromotionParam).then((res) => {
            if (res.body.result === true) {
              var isshowPromotion = {}
              isshowPromotion.showPromotionParam = showPromotionParam
              isshowPromotion.show = true
              Emkt.setLocalStorage('isshowPromotion', isshowPromotion)
            }
          })
        }
      }
    }
  })
  .then(function (response) {
    if (!Emkt.isWapp) {
      if (store.getters.hasLogin && store.state.sessionInfo.customerInfo.customerNo) {
        gcapi('getRecommendation', store.state.sessionInfo.customerInfo.customerNo).then((res) => {
          if (res.body.result.length > 0) {
            var i = 0
            var list = []
            var newlist = res.body.result
            // console.log(res.body.result)
            if (newlist.length > 15) {
              for (i = 0; i < 15; i++) {
                list.push(newlist[i])
              }
              Emkt.setStoreItem('EmktRecommendations', list)
            } else {
              Emkt.setStoreItem('EmktRecommendations', newlist)
            }
          }
        })
      }
    }
  })
  .then(function () {
    console.log(Emkt.getUrlFullParamValue('QuoteId'))
    if (Emkt.getUrlParamHref('fromSmart') === '1' && Emkt.getUrlFullParamValue('QuoteId')) {
      gcapi('getQuoteShoppingCart', Emkt.getUrlFullParamValue('QuoteId')).then(res => {
        if (res && res.body.code === 0 && res.body.result) {
          // if (store.state.sessionInfo.customerInfo.customerProperties && store.state.sessionInfo.customerInfo.customerProperties.QuoteShoppingCart) {
          //   let shoppingCart = store.state.sessionInfo.customerInfo.customerProperties.QuoteShoppingCart
          let list = JSON.parse(res.body.result.cartContent)
          console.log('cartContent', list)
          let ar = []
          Object.keys(list).forEach(l => {
            console.log('isChecked', list[l].isChecked)
            if (list[l].isChecked) {
              ar.push(Emkt.convertProduct(list[l]))
            }
          })
          store.state.checkList = ar
          store.state.cartList.cartContent = list
          // }
        }
      })
    }
  })
  .then(function () {
    if (!Emkt.isWapp) {
      return gcapi('getChannel')
    }
  })
  .then(function (res) {
    if (!Emkt.isWapp) {
      if (res.body.result.length > 0) {
        Emkt.setStoreItem('EmktChannels', res.body.result)
      }
    }
  })
  // .then(function () {
  //   if (!Emkt.isWapp) {
  //     return gcapi('getAllToolVectors')
  //   }
  // })
  // .then(function (res) {
  //   if (!Emkt.isWapp) {
  //     // console.log(res)
  //     let toolVectors = res.body.result
  //     console.log(toolVectors)
  //     Emkt.setStoreItem('toolVectors', toolVectors)
  //   }
  // })
  .then(function () {
    if (!Emkt.isWapp) {
      return gcapi('getCustData')
    }
  })
  .then(function (res) {
    if (!Emkt.isWapp) {
      // console.log(res)
      var custdata = JSON.parse(res.body.result).custdata
      // console.log(custdata)
      // let newData = initCustData(JSON.parse(JSON.stringify(custdata)), Emkt.getStoreItem('toolVectors'))
      // console.log('data', custdata, 'newData', newData)
      Emkt.setStoreItem('custdata', custdata)
    }
  })
  .then(function () {
    if (!Emkt.isWapp) {
      return gcapi('getBillInfoBlacklist')
    }
  })
  .then(function (res) {
    if (!Emkt.isWapp) {
      Emkt.setStoreItem('EmktBillInfoBlacklist', res.body.result)
      // if (res.body.result !== null && store.state.sessionInfo.customerInfo.customerNo) {
      //   if (res.body.result.indexOf(store.state.sessionInfo.customerInfo.customerNo) !== -1) {
      //     store.state.showBillInfo = false
      //   } else {
      //     store.state.showBillInfo = true
      //   }
      // }
      // console.log(res)
    }
  })
  .then(function () {
    if (Emkt.getUrlParamHref('sso_processed') === '1') {
      return gcapi('getAllCustomizedMerchandise')
    }
  })
  .then(function (res) {
    if (Emkt.getUrlParamHref('sso_processed') === '1') {
      var merch = res.body.result[0]
      merch._curStep = 0
      Emkt.setStoreItem('EmktCustomizedMerchandise', merch)
    }
  })
  // .then(function () {
  //   var param = {}
  //   param.text = ''
  //   param.fromIndex = 0
  //   param.findFilters = []
  //   return gcapi('find', param)
  // })
  // .then(function (res) {
  //   store.state.findFilters =
  // })
  // .then(function () {
  //   $.getJSON('/static/dingz1.json', function (res) {
  //     $.each(res, function (infoIndex, info) {
  //       console.log(info)
  //       Emkt.setStoreItem('dingzhi', info)
  //     })
  //   })
  // })
  // .then(function () {
  //   return gcapi('getRecommendation', 'GUEST')
  // })
  // .then(function (res) {
  //   if (res.body.result.length > 0) {
  //     var mlist = []
  //     mlist = res.body.result
  //     var merchList = []
  //     for (var n = 0; n < mlist.length; n = n + 3) {
  //       var swaperlist = []
  //       swaperlist.push(mlist[n])
  //       swaperlist.push(mlist[n + 1])
  //       swaperlist.push(mlist[n + 2])
  //       merchList.push(swaperlist)
  //     }
  //     Emkt.setStoreItem('EmktRecommendations', merchList)
  //   } else {
  //     var recommendations = []
  //     Emkt.setStoreItem('EmktRecommendations', recommendations)
  //   }
  // })
  // .then(function () {
  //   return gcapi('getApplicableMerchandiseLiteList', 'plain-1')
  // })
  // .then(function (res) {
  //   if (res.body.result.length > 0) {
  //     getApplicableMerchandiseLiteList(res)
  //   } else {
  //     var merchList = []
  //     Emkt.setStoreItem('EmktPlain', merchList)
  //   }
  // })
  .then(function () {
    var app = new Vue({
      el: '#app',
      store,
      router,
      render: h => h(App)
    })
    window.app = app
  })
  .then(function () {
    if (store.getters.hasLogin && store.state.sessionInfo.customerInfo) {
      const customerNo = store.state.sessionInfo.customerInfo.customerNo
      // let customerNo = Emkt.testCustomerNo   // member '00224747'   leader '00198019'
      // 获取所有的课题组信息
      gcapi('getResearchGroupInfoListByCustomerNo', customerNo).then(res => {
        if (res && res.body.result) {
          store.state.researchGroupMemberMap = res.body.result.bResearchGroupMemberMap
          store.state.researchGroupSet = res.body.result.bResearchGroupList
          // console.log('researchGroupMemberMap', store.state.researchGroupMemberMap, store.state.researchGroupSet)
        }
      })

      // 过滤掉无效的任职关系
      gcapi('getWorkExperienceList', customerNo).then(res => {
        if (res && res.body.result) {
          const workList = res.body.result.filter(work => {
            return work.enable === true
          })
          Emkt.setStoreItem('EmktWorkExperienceList', workList)
        } else {
          Emkt.setStoreItem('EmktWorkExperienceList', [])
        }
        // console.log('EmktWorkExperienceList', Emkt.getLocalStorage('EmktWorkExperienceList'))
      })
    }
    if (!Emkt.isWapp) {
      gcapi('getRecommended').then(function (response) {
        Emkt.setStoreItem('EmktAllRecommends', response.body.result)
      })
      if (store.state.sessionInfo.customerInfo) {
        gcapi('retrieveMyOrder').then(function (response) {
          let res = response.body
          store.state.myOrder = res.result
        })
      }
    }
    // 课题组成员选择框
    new Vue({
      el: '#ResearchGroupMemberBox',
      store,
      router,
      render: h => h(ResearchGroupMemberBox)
    })
    new Vue({
      el: '#SearxhBox',
      store,
      router,
      render: h => h(SearxhBox)
    })
    gcapi('gcwwwifc/listEnterprise').then(function (response) {
      if (response.body.result) {
        // 过滤出所有的一级单位信息
        const firstLevelEnterpriseList = response.body.result.filter(enterprise => {
          return enterprise.enterpriseLevel === 1
        })
        const firstLevelInvoiceTitleMap = {}
        const enterpriseInvoiceTitleList = []
        const enterpriseNoMap = {}
        firstLevelEnterpriseList.forEach(enterprise => {
          if (enterprise.enterpriseInvoiceTitle !== '' && enterprise.enterpriseInvoiceTitle !== undefined) {
            let firstLevelEnterprise = firstLevelInvoiceTitleMap[enterprise.enterpriseInvoiceTitle]
            if (firstLevelEnterprise === undefined) {
              let invoiceTitleList = []
              let invoice = {
                'enterpriseInvoiceTitle': enterprise.enterpriseInvoiceTitle
              }
              invoiceTitleList.push(enterprise)
              invoice.enterpriseList = invoiceTitleList
              firstLevelInvoiceTitleMap[enterprise.enterpriseInvoiceTitle] = invoice
            } else {
              let invoiceTitleList = firstLevelEnterprise.enterpriseList
              invoiceTitleList.push(enterprise)
              firstLevelInvoiceTitleMap[enterprise.enterpriseInvoiceTitle] = firstLevelEnterprise
            }
            let invoiceTitle = {
              'enterpriseInvoiceTitle': enterprise.enterpriseInvoiceTitle
            }
            if (!enterpriseInvoiceTitleList.includes(invoiceTitle) && enterprise.enterpriseType !== Emkt.ENTERPRISE_TYPE_COMPANY) {
              enterpriseInvoiceTitleList.push(invoiceTitle)
            }
            enterpriseNoMap[enterprise.enterpriseNo] = enterprise
          }
        })
        Emkt.setStoreItem('EmktFirstLevelEnterpriseNoMap', enterpriseNoMap)
        Emkt.setStoreItem('EmktEnterpriseInvoiceTitleList', enterpriseInvoiceTitleList)
        Emkt.setStoreItem('EmktFirstLevelInvoiceTitleMap', firstLevelInvoiceTitleMap)
        Emkt.setStoreItem('EmktFirstLevelEnterpriseList', firstLevelEnterpriseList)
        // console.log('firstLevelEnterpriseMap', firstLevelInvoiceTitleMap)
        // console.log('EmktEnterpriseInvoiceTitleList', enterpriseInvoiceTitleList)
        new Vue({
          el: '#EnterpriseBox',
          store,
          router,
          render: h => h(EnterpriseBox)
        })
        new Vue({
          el: '#invoiceTitleBox',
          store,
          router,
          render: h => h(InvoiceTitleBox)
        })
      }
    })
    new Vue({
      el: '#searchGeneBox',
      store,
      router,
      render: h => h(SearchGeneBox)
    })
    new Vue({
      el: '#popuptextbox',
      store,
      router,
      render: h => h(PoPupTextBox)
    })
    new Vue({
      el: '#searchFilterPanel',
      store,
      router,
      render: h => h(SearchFilterPanel)
    })

    $(document).on('click', '.open-goods', function () {
      Emkt.setStoreItem('isPopUpOpen', true)
    })
    $(document).on('click', '.close-popup', function () {
      Emkt.setStoreItem('isPopUpOpen', false)
    })
    /*
    if (router.currentRoute !== undefined && router.currentRoute.name === 'welcome') {
      // console.log(router.currentRoute)
      router.replace('home')
    }
    */
  })
  .catch(function (error) {
    // console.log('Initialization failed.')
    // console.log(error)
    var msg = error.message
    $.toast(msg)
  })

// function initCustData (custData, toolVectors) {
//   custData.forEach(data => {
//     if (data.name.indexOf('扩增') === -1 && data.name.indexOf('质粒抽提') === -1) {
//       data.TVInfo = toolVectors.filter(tv => {
//         let result = tv.contractType && tv.contractType.split(',').filter(item => item === data.name) || []
//           // console.log(tv.contractType && tv.contractType.split(','), result)
//         return result.length > 0
//       }
//       ).map(tv => ({value: tv.TLNo})) || []
//     }
//   })
//   return custData
// }
function getHotPromotions (res) {
  var discounts = []
  var promotions = []
  var showpromotions = []
  var specialcouponpromotions = []
  discounts = res.body.result
  if (res.body.code !== 0) {
    return
  }
  for (var i = 0; i < discounts.length; i++) {
    if (discounts[i].type !== 0) {
      promotions.push(discounts[i])
    }
    if (discounts[i].type === 0) {
      Emkt.setStoreItem('EmktDiscounts', discounts[i])
    }
    if (discounts[i].acknowledge === 1) {
      showpromotions.push(discounts[i])
    }
    if (discounts[i].requiredCustomers === 1) {
      specialcouponpromotions.push(discounts[i])
    }
  }
  Emkt.setStoreItem('EmktShowPromotions', showpromotions)
  Emkt.setStoreItem('EmktPromotions', promotions)
  Emkt.setStoreItem('EmktSpecialcouponpromotions', specialcouponpromotions)
}
function getSecPromotion () {
  var promotions = Emkt.getLocalStorage('EmktPromotions')
  Emkt.setStoreItem('EmktSecPromotion', '') // 全局唯一 监测秒杀是否结束
  const secInfoList = {}
  for (let promotion of promotions) {
    if (promotion.type === 6 || promotion.type === '6') {
      if (!Emkt.getLocalStorage('EmktSecPromotion')) {
        Emkt.setStoreItem('EmktSecPromotion', promotion)
      }
      gcapi('getSeckillPromotion', promotion.promotionGuid)
          .then((response) => {
            const result = response.body.result
            secInfoList[promotion.promotionGuid] = Object.assign({}, promotion, result)
            store.state.secPromotionDetailObj = secInfoList // 同一时刻所有的秒杀详情集合
            // console.log('store.state.secPromotionDetailObj', store.state.secPromotionDetailObj)
          })
    }
  }
}
// function getApplicableMerchandiseLiteList (res) {
//   var mlist = []
//   mlist = res.body.result
//   var merchList = []
//   for (var n = 0; n < 9; n = n + 3) {
//     var swaperlist = []
//     swaperlist.push(mlist[n])
//     swaperlist.push(mlist[n + 1])
//     swaperlist.push(mlist[n + 2])
//     for (var i = 0; i < swaperlist.length; i++) {
//       var tags = []
//       var merchandiseMeta = Emkt.getEmktMetaData()
//       var tagsmap = merchandiseMeta.tagsMap
//       for (var j = 0; j < swaperlist[i].tagIds.length; j++) {
//         tags.push(tagsmap[swaperlist[i].tagIds[j]].tagLabel)
//       }
//       swaperlist.tags = tags
//       swaperlist[i].attrs = swaperlist[i]._attributesList
//     }
//     merchList.push(swaperlist)
//   }
//   Emkt.setStoreItem('EmktPlain', merchList)
// }
// for debug
function capi (func, para) {
  gcapi(func, para).then((response) => {
    // return response
    // console.log(response.body)
  })
}
window.gcapi = gcapi
window.capi = capi
// console.log('Vue App created')
window.$ = $
window.store = store
// console.log('Emkt App created')

if (Emkt.isDebug) {
// 加载控制台
  const loadScript = (url, callback) => {
    const script = document.createElement('script')
    script.onload = () => callback()
    script.src = url
    document.body.appendChild(script)
  }

  loadScript(
    'https://res.wx.qq.com/mmbizwap/zh_CN/htmledition/js/vconsole/3.0.0/vconsole.min.js',
    () => {
      var VConsole = window.VConsole
      new VConsole()
    })
}



// WEBPACK FOOTER //
// ./src/main.js